export enum PersonTypeEnum {
    PHYSICAL = 'P',
    LEGAL = 'L'
}